var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticStyle: { "text-align": "center" } },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("h2", [_vm._v("聚合支付")]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 24 } },
              [
                _c("qrcode", {
                  attrs: { value: _vm.msg, options: _vm.options },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _c("h4", [_vm._v("请使用微信或支付宝手机客户端扫一扫")]),
            ]),
          ],
          1
        ),
        _c("el-row", [_vm._v(" 请勿大额支付，无法退还请知悉 2")]),
        _c(
          "el-row",
          [
            _c(
              "el-radio",
              {
                attrs: { label: "1" },
                model: {
                  value: _vm.amount,
                  callback: function ($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount",
                },
              },
              [_vm._v("0.01 元")]
            ),
            _c(
              "el-radio",
              {
                attrs: { label: "10" },
                model: {
                  value: _vm.amount,
                  callback: function ($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount",
                },
              },
              [_vm._v("0.1 元")]
            ),
            _c(
              "el-radio",
              {
                attrs: { label: "100" },
                model: {
                  value: _vm.amount,
                  callback: function ($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount",
                },
              },
              [_vm._v("1 元")]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-radio",
              {
                attrs: { label: "0" },
                model: {
                  value: _vm.type,
                  callback: function ($$v) {
                    _vm.type = $$v
                  },
                  expression: "type",
                },
              },
              [_vm._v("聚合支付")]
            ),
            _c(
              "el-radio",
              {
                attrs: { label: "1" },
                model: {
                  value: _vm.type,
                  callback: function ($$v) {
                    _vm.type = $$v
                  },
                  expression: "type",
                },
              },
              [_vm._v("普通模式")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }